import React from 'react';
import styled from 'styled-components';
import { WebsiteUploadsDocumentSelection } from '@containers/DigitalAnalyst/components/WebsiteUploadsDocumentSelection';
import { FedDocumentSelection } from '@containers/DigitalAnalyst/components/FedDocumentSelection';
import { CustomModeDocumentSelection } from '@containers/DigitalAnalyst/components/CustomModeDocumentSelection';
import { PresetDocumentSelection } from '@containers/DigitalAnalyst/components/PresetDocumentSelection';
import { CompanyTagDocumentSelection } from '@containers/DigitalAnalyst/CompanyTagDocumentSelection';
import { SpeakerDocumentSelection } from '@containers/DigitalAnalyst/SpeakerDocumentSelection';
import { useSelectedDocs } from './useSelectedDocs';

/**
 * Thin context adapters that let the existing, bespoke mode UIs render inside the
 * shared DocumentSelectionModal without prop drilling. Each reads/writes the
 * selection through FormStateContext (via useSelectedDocs) and forwards the
 * legacy props the wrapped component already expects.
 */

const CompanyTagDocumentSelectionWrapper = styled.div`
  input {
    border: 1px solid ${({ theme }) => theme.themeColors.border} !important;
  }
`;

export const WebsiteDocumentSelection = () => {
  const { selectedDocs, onAddDocument, onRemoveDocument } = useSelectedDocs();
  return (
    <WebsiteUploadsDocumentSelection
      selectedDocs={selectedDocs}
      onSelect={onAddDocument}
      onRemoveSelect={onRemoveDocument}
    />
  );
};

export const MacroDocumentSelection = () => {
  const { selectedDocs, onAddDocument, onRemoveDocument } = useSelectedDocs();
  return (
    <FedDocumentSelection selectedDocs={selectedDocs} onSelect={onAddDocument} onRemoveSelect={onRemoveDocument} />
  );
};

export const CustomDocumentSelection = ({ tool }) => {
  const { selectedDocs, onAddDocument, onRemoveDocument } = useSelectedDocs();
  return (
    <CustomModeDocumentSelection
      tool={tool}
      selectedDocs={selectedDocs}
      handleAddDocument={onAddDocument}
      handleRemoveDocument={onRemoveDocument}
    />
  );
};

export const PresetModeDocumentSelection = ({ presetParams, onDismiss }) => {
  const { selectedDocs, onAddDocument, onRemoveDocument } = useSelectedDocs();
  return (
    <PresetDocumentSelection
      presetParams={presetParams}
      selectedDocs={selectedDocs}
      handleAddDocument={onAddDocument}
      handleRemoveDocument={onRemoveDocument}
      onDismiss={onDismiss}
    />
  );
};

export const CompanyTagModeSelection = () => {
  const { selectedDocs, onAddDocument, onRemoveDocument } = useSelectedDocs();
  return (
    <CompanyTagDocumentSelectionWrapper>
      <CompanyTagDocumentSelection
        selectedDocs={selectedDocs}
        onSelect={onAddDocument}
        onRemoveSelect={onRemoveDocument}
      />
    </CompanyTagDocumentSelectionWrapper>
  );
};

export const SpeakerModeSelection = () => {
  const { selectedDocs, onAddDocument, onRemoveDocument } = useSelectedDocs();
  return (
    <SpeakerDocumentSelection selectedDocs={selectedDocs} onSelect={onAddDocument} onRemoveSelect={onRemoveDocument} />
  );
};
